import React from "react";
import { RCCChartGantt, RCCChartGanttDataType } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";

const defaultOpts = {
	vCaptionType: "None",  // Set to Show Caption : None, Caption, Resource, Duration, Complete,
	vRowHeight: 40,
	vHourColWidth: 21,
	vDayColWidth: 27,
	vWeekColWidth: 45,
	vMonthColWidth: 120,
	vQuarterColWidth: 240,
	vTooltipDelay: 50,
	vUseSort: "true"
};

const optionsDefaultPT = {
	...defaultOpts,
	vDateTaskDisplayFormat: "day dd month yyyy", // Shown in tool tip box
	vDayMajorDateDisplayFormat: "mon yyyy - Week ww", // Set format to display dates in the "Major" header of the "Day" view
	vWeekMinorDateDisplayFormat: "dd mon",
	vLang: "pt"
};

const optionsDefaultEN = {
	...defaultOpts,
	vDateTaskDisplayFormat: "month day dd yyyy", // Shown in tool tip box
	vDayMajorDateDisplayFormat: "mon yyyy - Week ww", // Set format to display dates in the "Major" header of the "Day" view
	vWeekMinorDateDisplayFormat: "mon dd",
	vLang: "en"
};

const optionLanguages = {
	"en": optionsDefaultEN,
	"pt": optionsDefaultPT,
	"es": optionsDefaultPT
};

interface IGanttChartComponent{
    data: RCCChartGanttDataType[];
	onCreateDependants?: (from: RCCChartGanttDataType, to: RCCChartGanttDataType) => Promise<void>;
	verifyIfCreateDependants?: (data: RCCChartGanttDataType) => boolean;
	allowCreateDependants?: boolean;
} 

const GanttChart: React.FC<IGanttChartComponent> = ({
	data,
	allowCreateDependants,
	onCreateDependants,
	verifyIfCreateDependants
}) => {
	const { currentLanguage } = useTranslation();

	return(
		<RCCChartGantt 
			data={data} 
			options={optionLanguages[currentLanguage] as any}
			allowCreateDependants={allowCreateDependants}
			onCreateDependants={onCreateDependants}
			verifyIfCreateDependants={verifyIfCreateDependants}
		/>
	);};

export default GanttChart;
